import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClipboardList
} from "react-icons/fa";
import EnquiryForm from './EnquiryForm'; // Ensure this path is correct

const ContactSection = () => {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  return (
    <section
      id="contact"
      style={{
        background: "linear-gradient(135deg, #f8fafb 0%, #ffffff 100%)",
        padding: "80px 20px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Decor */}
      <div
        style={{
          position: "absolute",
          top: "-100px",
          right: "-100px",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
          opacity: 0.05,
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-150px",
          left: "-150px",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
          opacity: 0.04,
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Section Header */}
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <span
            style={{
              display: "inline-block",
              backgroundColor: "#e6f7ee",
              color: "#38a169",
              fontWeight: 600,
              fontSize: "12px",
              padding: "6px 16px",
              borderRadius: "50px",
              textTransform: "uppercase",
              letterSpacing: "1px",
              marginBottom: "12px",
            }}
          >
            Get Started
          </span>

          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#1a202c",
              marginBottom: "12px",
              lineHeight: 1.2,
            }}
          >
            Start Your Wellness Journey
          </h2>

          <p
            style={{
              color: "#718096",
              fontSize: "16px",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Get personalized guidance and support from our experts.
          </p>
        </div>

        {/* Responsive Grid Layout */}
        <div className="contact-grid">
          
          {/* LEFT SIDE: New Box with Sentence & Button */}
          <div className="enquiry-card">
            <div className="icon-circle">
              <FaClipboardList />
            </div>

            <h3>Book Consultation</h3>

            {/* THE SENTENCE YOU REQUESTED */}
            <p>
              Please fill out the enquiry form below to share your health goals with us. We will review your details and connect with you shortly via WhatsApp.
            </p>

            {/* THE BUTTON */}
            <button
              onClick={() => setIsEnquiryOpen(true)}
              className="open-form-btn"
            >
              Open Enquiry Form
            </button>
          </div>

          {/* RIGHT SIDE: Contact Info (Stacked) */}
          <div className="contact-info-stack">
            <ContactCard
              icon={<FaPhoneAlt style={{ color: "#fff", fontSize: "18px" }} />}
              iconBg="linear-gradient(135deg, #48bb78 0%, #38a169 100%)"
              title="Call Us"
              content="+91 90031 49989"
            />

            <ContactCard
              icon={<FaEnvelope style={{ color: "#fff", fontSize: "18px" }} />}
              iconBg="linear-gradient(135deg, #4299e1 0%, #3182ce 100%)"
              title="Email Us"
              content="Karpagamdietitian@gmail.com"
            />

            <ContactCard
              icon={<FaMapMarkerAlt style={{ color: "#fff", fontSize: "18px" }} />}
              iconBg="linear-gradient(135deg, #ed8936 0%, #dd6b20 100%)"
              title="Visit Us"
              content={
                <>
                  Plot no. 7, Door no. 6, Pakkirisamy Pillai Street,
                  <br />
                  Eswari Nagar, Medical College Road,
                  <br />
                  Thanjavur, Tamil Nadu 613004
                </>
              }
            />

            <div className="map-container">
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.238217834743!2d79.13631477454653!3d10.78653398931767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baab89b36f3d3a1%3A0x6c7f7e9d7e9d7e9d!2sPlot%20no.%207%2C%20Door%20no.%206%2C%20Pakkirisamy%20Pillai%20Street%2C%20Eswari%20Nagar%2C%20Medical%20College%20Road%2C%20Thanjavur%2C%20Tamil%20Nadu%20613004!5e0!3m2!1sen!2sin!4v1692219454858!5m2!1sen!2sin"
                width="100%"
                height="220"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Render the Modal */}
      <EnquiryForm 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
      />

      {/* STYLES FOR RESPONSIVENESS (Mobile/Desktop) */}
      <style>{`
        /* Default Grid (Desktop/Laptop) */
        .contact-grid {
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: 30px;
          align-items: start;
        }

        /* Enquiry Card Styles */
        .enquiry-card {
          background: #fff;
          border-radius: 20px;
          padding: 60px 40px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.02), 0 10px 30px rgba(0,0,0,0.06);
          border: 1px solid rgba(226,232,240,0.8);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          min-height: 450px;
        }

        .icon-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: #e6f7ee;
          color: #38a169;
          font-size: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
        }

        .enquiry-card h3 {
          font-size: 24px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 16px;
        }

        .enquiry-card p {
          color: #718096;
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 32px;
          max-width: 80%;
        }

        .open-form-btn {
          padding: 16px 40px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
          color: #fff;
          border: none;
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(56, 161, 105, 0.4);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .open-form-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(56, 161, 105, 0.5);
        }

        .contact-info-stack {
          display: flex;
          flex-direction: column;
          gap: 20px;
          width: 100%;
        }

        .map-container {
          border-radius: 16px;
          overflow: hidden;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
        }

        /* MEDIA QUERY FOR MOBILE & TABLET */
        @media (max-width: 968px) {
          .contact-grid {
            grid-template-columns: 1fr; /* Stack vertically */
            gap: 40px;
          }

          .enquiry-card {
            padding: 40px 20px; /* Less padding on mobile */
            min-height: auto;
          }

          .enquiry-card p {
            max-width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

// Helper Sub-component for Right Side Cards
const ContactCard = ({ icon, iconBg, title, content }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "14px",
      background: "#fff",
      borderRadius: "16px",
      padding: "18px",
      boxShadow: "0 4px 6px rgba(0,0,0,0.02), 0 10px 30px rgba(0,0,0,0.06)",
      border: "1px solid rgba(226,232,240,0.8)",
      cursor: "default",
    }}
  >
    <div
      style={{
        padding: "12px",
        borderRadius: "12px",
        background: iconBg,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "48px",
        minHeight: "48px",
      }}
    >
      {icon}
    </div>

    <div>
      <h4
        style={{
          fontSize: "14px",
          fontWeight: 700,
          marginBottom: "4px",
          color: "#1a202c",
        }}
      >
        {title}
      </h4>
      <p style={{ fontSize: "12px", color: "#718096", margin: 0 }}>
        {content}
      </p>
    </div>
  </div>
);

export default ContactSection;
